
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { logoutViaApi } from "../helpers/misc";
import Cookies from 'js-cookie';

type UserState = {
   user: any;
   userInfo: any;
   userAuth: any;
   isAuthenticated: boolean;
   plainUserInfo: null | any;
   deviceId?: string;
   fcmToken?: string;
   isRerouting: boolean;
   currentBanner: any;
   sessionReloadOpen: boolean;
};

const initialState: UserState = {
   user: null,
   userInfo: null,
   isAuthenticated: false,
   userAuth: null,
   plainUserInfo: null,
   deviceId: undefined,
   fcmToken: undefined,
   isRerouting: false,
   currentBanner: null,
   sessionReloadOpen: false,
};

const userSlice = createSlice({
   name: "user",
   initialState,
   reducers: {

      loginUser: (state, { payload }: PayloadAction<any>) => {
         return {
            ...state,
            user: payload,
            userInfo: payload?.endUser ? payload?.endUser[0] : payload?.enduser[0],
            userAuth: payload?.authenticator,
            plainUserInfo: payload?.endUser ? payload?.endUser[0] : payload?.enduser[0],
            isAuthenticated: true,
            isRerouting: false,
         }
      },

      logoutUser: (state) => {
         Cookies.remove("qwid-token");

         return {
            ...state,
            user: null,
            userInfo: null,
            userAuth: null,
            plainUserInfo: null,
            isAuthenticated: false,
            isRerouting: true
         }
      },

      clearUser: () => {
         return initialState
      },

      setPlainUser: (state, { payload }: PayloadAction<any>) => {
         return {
            ...state,
            plainUserInfo: payload,
         };
      },

      setUserInfo: (state, { payload }: PayloadAction<any>) => {
         return {
            ...state,
            userInfo: payload,
         }
      },

      setFcmDetails: (state, { payload }: PayloadAction<{ deviceId: string; fcmToken: string }>) => {
         return {
            ...state,
            ...payload,
         };
      },

      updateUserAuth: (state, { payload }: PayloadAction<any>) => {
         const exists = state.userAuth.some((item: any) => item.type === payload.type);

         return {
            ...state,
            userAuth: exists ? state.userAuth.map((item: any) => item.type === payload.type ? payload : item)
               : [...state.userAuth, payload]
         };
      },

      updateCurrentBanner: (state, { payload }: PayloadAction<any>) => {
         return {
            ...state,
            currentBanner: payload
         };
      },

      openSessionReload: (state) => {
         return {
            ...state,
            sessionReloadOpen: true
         };
      },

      closeSessionReload: (state) => {
         return {
            ...state,
            sessionReloadOpen: false,
         };
      },

   },

   extraReducers: (builder) => {
      builder
         .addCase(logoutViaApi.pending, (state) => {
            Cookies.remove("qwid-token");
            state.isRerouting = true;
            state.user = null;
            state.isAuthenticated = false;
         })
         .addCase(logoutViaApi.fulfilled, (state) => {
            state.isRerouting = false;
            state.user = null;
            state.isAuthenticated = false;
         })
         .addCase(logoutViaApi.rejected, (state) => {
            state.isRerouting = false;
            state.user = null;
            state.isAuthenticated = false;
         });
   }
});

export const {
   loginUser,
   logoutUser,
   setFcmDetails,
   setPlainUser,
   clearUser,
   setUserInfo,
   updateUserAuth,
   updateCurrentBanner,
   openSessionReload,
   closeSessionReload,
} = userSlice.actions;
export default userSlice.reducer;
